
import { Component, Prop, Vue } from "vue-property-decorator";
import ListKeyItem from "@/components/list/ListKeyItem.vue";
import KeyStatus from "@/components/keys/KeyStatus.vue";
import CustomChipLink from "@/components/CustomChipLink.vue";
import { Getter } from "vuex-class";
import SvgIcon from "@jamescoyle/vue-icon";
import { getTokenLink } from "@/utils/misc";

import { mdiFocusFieldHorizontal } from "@mdi/js";

@Component({
  components: {
    KeyStatus,
    ListKeyItem,
    CustomChipLink,
    SvgIcon,
  },
})

export default class CardKey extends Vue {

  get lang(): any {
    return this.$root.$i18n.locale;
  }

  @Prop({ default: null })
  public item: any;

  @Getter private currentUser: any;
  @Getter private isBookedKeyAvailable: (key: any) => boolean;
  private getTokenLink: (string) => string = getTokenLink;

  private mdiFocusFieldHorizontal = mdiFocusFieldHorizontal;

  private isCompanyKeyBlocked(key: any) {
    return key?.company && !!key.company.blockedAt;
  }

  private displayCodeName(key): void {
    if (key.backupId) {
      let codeName;
      try {
        const s = key.locationDisplayed.codeName.split("-");
        codeName = s[s.length - 1];
      } catch {
        codeName = "";
      }
      return codeName;
    } else {
      return key.locationDisplayed.codeName;
    }
  }
}
